// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-new-period {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.add-new-period .card-body {
  padding: 20px;
}
.add-new-period .new-period .btn.btn-primary {
  padding: 8px 45px;
  border-radius: 2.08rem;
}
.add-new-period .new-period .btn.btn-outline-primary {
  padding: 8px 35px;
  border-radius: 2.08rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
